export enum DefaultFirstBoard {
    dinner = "dinner",
    breakfast = "breakfast",
    lunch = "lunch",
    nothing = "nothing"
}